import React from 'react'
import { connect } from 'react-redux'

import '../asset/less/component.css'
import '../asset/less/Showcase.css'

import { Button, Col, Modal, Row } from 'antd'

import Gallery from '../component/react-grid-gallery/src/Gallery' //https://www.npmjs.com/package/react-grid-gallery
import ImageDisplay from '../component/ImageDisplay'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { withRouter } from 'react-router'

@connect((state) => ({
  //decorator, gives component access to the state
  siderWidth: state.style.siderWidth,
  id: state.user.info.id,
  userId: state.user.info.userId,
  artistId: state.user.info.artistId,
  artistName: state.user.info.artistName
}))
class ArtworkDisplayOrderPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      artworks: props.artworks ?? [], //artworks is the array for the SAM gallery
      artworks_orders: props.artworks_orders ?? [],
      original_artworks_orders: props.artworks_orders ?? [],
      selected: 0, //my own tracking variable for selected art
      previewVisible: false //for preview modal
    }
    this.updateArtworkOrder(props.artworks, props.artworks_orders)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.artworks !== this.props.artworks || prevProps.artworks_orders !== this.props.artworks_orders) {
      this.setState({
        artworks: this.props.artworks,
        artworks_orders_json: this.props.artworks_orders,
        original_artworks_orders: this.props.artworks_orders
      })
      this.updateArtworkOrder(this.props.artworks, this.props.artworks_orders)
    }
  }

  updateArtworkOrder = (artworks, artworks_orders) => {
    try {
      if (!artworks_orders || artworks_orders.length === 0) return
      let order_json = {}
      artworks_orders.forEach((order) => {
        Object.keys(order).forEach((key) => {
          order_json[key] = order[key]
        })
      })
      const sorted_artworks = artworks.sort((a, b) => {
        return order_json[a.key] - order_json[b.key]
      })
      this.setState({
        artworks: sorted_artworks
      })
    } catch (e) {
      console.log(e)
    }
  }

  notifyChange = (artworks_orders) => {
    const arrayEquals = (a, b) => {
      return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index])
    }
    if (!arrayEquals(this.state.artworks_orders, artworks_orders)) {
      if (this.props.onOrderChange) {
        this.props.onOrderChange(artworks_orders)
      }
    }
  }

  getCurrentArtworkOrder = () => {
    let array = []
    this.state.artworks.forEach((artwork, index) => {
      let dict = {}
      dict[artwork.key] = index + 1
      array.push(dict)
    })
    return array
  }

  componentDidMount() {}

  selectImage = (index, image) => {
    for (const artwork of this.state.artworks) {
      artwork.isSelected = false
    }
    image.isSelected = true
    this.setState({
      selected: index
    })
  }

  shiftLeft = () => {
    const { artworks, selected } = this.state
    if (this.state.selected > 0) {
      //swap array
      let temp = artworks[selected]
      artworks[selected] = artworks[selected - 1]
      artworks[selected - 1] = temp

      this.setState({
        artworks: artworks,
        selected: selected - 1,
        artworks_orders: this.getCurrentArtworkOrder()
      })
      this.notifyChange(this.getCurrentArtworkOrder())
    }
  }

  shiftRight = () => {
    const { artworks, selected } = this.state
    if (selected < artworks.length - 1) {
      let temp = artworks[selected]
      artworks[selected] = artworks[selected + 1]
      artworks[selected + 1] = temp

      this.setState({
        artworks: artworks,
        selected: selected + 1,
        artworks_orders: this.getCurrentArtworkOrder()
      })
      this.notifyChange(this.getCurrentArtworkOrder())
    }
  }

  onReset = () => {
    this.updateArtworkOrder(this.props.artworks, this.state.original_artworks_orders)
    this.notifyChange(this.state.original_artworks_orders)
  }

  enterPreviewHandler = () => {
    this.setState({
      previewVisible: true
    })
  }

  exitPreviewHandler = () => {
    this.setState({
      previewVisible: false
    })
  }

  render() {
    return (
      <div className='site-layout-background' style={{ padding: '1rem' }}>
        <p>
          <i>Move images and arrange them in the order you prefer.</i>
        </p>
        <Row justify='space-between'>
          <Col span={10} id='leftArrow'>
            <Button type='primary' size='middle' style={{ float: 'right' }} icon={<LeftOutlined />} onClick={this.shiftLeft}>
              Move left
            </Button>
          </Col>
          <Col span={10} id='rightArrow'>
            <Button type='primary' size='middle' icon={<RightOutlined />} onClick={this.shiftRight}>
              Move right
            </Button>
          </Col>
          <div>
            <Button style={{ marginTop: 12 }} type='link' onClick={this.enterPreviewHandler}>
              Click to Preview
            </Button>
            <Button style={{ marginTop: 12 }} type='text' danger onClick={this.onReset}>
              Reset Orders
            </Button>
          </div>
        </Row>
        <div className='gallery'>
          <Gallery images={this.state.artworks} enableImageSelection={true} onSelectImage={this.selectImage} />
        </div>
        <Modal visible={this.state.previewVisible} title='Artwork Preview' onCancel={this.exitPreviewHandler} footer={null}>
          <ImageDisplay imageArray={this.state.artworks} />
        </Modal>
      </div>
    )
  }
}

export default withRouter(ArtworkDisplayOrderPanel)
